import { createStore } from "jotai";

// Single global store for all hwy-design-system atoms.
// Ensures state is shared across nested Jotai <Provider> boundaries.
export const hwyStore = createStore();
